import { Button, Group } from "@mantine/core"
import {
  IconBrandDocker,
  IconFileInvoice,
  IconFocus,
  IconList,
  IconShield,
  IconSparkles,
  IconTag,
  IconZoomMoney,
  IconCube,
} from "@tabler/icons-react"
import { useMemo } from "react"

import { GroupByButtonsProps } from "@costory/types/endpoints/DropdownTypes"

import { ICON_STROKE } from "@costory/shared/const"

import { ICON_SIZE } from "@costory/front/components/dropdown/constants"

const iconListElement = <IconList size={ICON_SIZE} stroke={ICON_STROKE} />

const labelIconMap: Record<string, JSX.Element> = {
  All: iconListElement,
  Labels: iconListElement,
  Suggested: <IconSparkles size={ICON_SIZE} stroke={ICON_STROKE} />,
  Costory: <IconShield size={ICON_SIZE} stroke={ICON_STROKE} />,
  Kubernetes: <IconBrandDocker size={ICON_SIZE} stroke={ICON_STROKE} />,
  "Virtual Dimensions": <IconFocus size={ICON_SIZE} stroke={ICON_STROKE} />,
  Invoice: <IconFileInvoice size={ICON_SIZE} stroke={ICON_STROKE} />,
  Cost: <IconCube size={ICON_SIZE} stroke={ICON_STROKE} />,
  Formula: <IconZoomMoney size={ICON_SIZE} stroke={ICON_STROKE} />,
}

const getTourClassForGroupPill = (groupName: string): string => {
  const formattedName = groupName.toLowerCase().replace(/\s+/g, "-")

  // Determine if this is for metrics or groupby based on the group name
  const prefix = ["Cost", "Formula"].includes(groupName)
    ? "costory-tour-metric-pill"
    : "costory-tour-groupby-pill"

  return `${prefix}-${formattedName}`
}

const GroupPills = ({
  sortedGroupByOptions,
  selectedGroup,
  setSelectedGroup,
  hasSuggestedAxes = false,
  showAllPill,
}: GroupByButtonsProps) => {
  const allGroups = useMemo(() => {
    const groupNames = sortedGroupByOptions
      .map(({ group }) => group)
      .filter((g) => g !== "Suggested")
    const groups = []
    if (showAllPill !== false) groups.push("All")
    if (hasSuggestedAxes) groups.push("Suggested")
    groups.push(...groupNames)
    return groups
  }, [sortedGroupByOptions, hasSuggestedAxes, showAllPill])

  return (
    <Group gap="xs" px="md" pt="md" pb="md">
      {allGroups.map((groupName) => (
        <Button
          key={groupName}
          variant={selectedGroup === groupName ? "filled" : "light"}
          color="primary"
          onClick={() => setSelectedGroup(groupName)}
          leftSection={
            labelIconMap[groupName] || (
              <IconTag size={ICON_SIZE} stroke={ICON_STROKE} />
            )
          }
          px={10}
          py={4}
          h={25}
          size="xs"
          data-intercom-target={getTourClassForGroupPill(groupName)}
        >
          {groupName}
        </Button>
      ))}
    </Group>
  )
}

export default GroupPills
